/* eslint-disable react/require-default-props */
import { useNavigate } from "react-router-dom";
import { FunctionComponent, MouseEvent } from "react";
import { resources } from "../../utils/resources";
import styles from "./BackButton.module.scss";

interface BackButtonProps {
  text: string;
  className?: string;
  round?: boolean;
  onClick?: (e: MouseEvent) => void;
}

const BackButton: FunctionComponent<BackButtonProps> = (props) => {
  const navigate = useNavigate();

  const { text, className, round, onClick } = props;

  const handleClick = (e: MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate(-1);
    }
  };

  return (
    <div
      className={[styles.wrapper, className, round && styles.round].join(" ")}
      onClick={handleClick}
      role="link"
      title={round ? text : undefined}
    >
      {round ? (
        <span className={styles["round-caret"]} />
      ) : (
        <>
          <img
            alt="go back"
            className={styles.image}
            src={resources.icons.ARROW_LEFT_SOLID}
          />
          {text && <strong className={styles.text}>{text}</strong>}
        </>
      )}
    </div>
  );
};

export default BackButton;
